import React from 'react';

export default function Layout({ children, wide = false }) {
  return (
    <div className={`app-layout ${wide ? 'app-layout--wide' : ''}`}>
      {children}
    </div>
  );
}
